function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#374151"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7113 21.5787C39.4113 21.5787 39.2688 16.1506 31.9544 16.1506C28.0019 16.1506 24.3137 17.9881 22.75 19.3269V14H19L19 59H22.75L22.75 41.9881C24.97 40.4525 28.3356 38.8363 31.9806 38.8363C38.8881 38.8363 39.8575 44 46.0131 44C49.9919 44 52.75 41.4519 52.75 41.4519V18.8994C52.75 18.8994 49.7106 21.5787 45.7113 21.5787ZM49 31.3719C44.4681 34.7038 39.5706 30.7344 37.0938 29.0994V35.9788L37.0994 35.9806C35.68 35.4575 34.015 35.0863 31.9806 35.0863C28.27 35.0863 25.0244 36.3594 22.75 37.5969V30.4906C26.9875 26.7931 33.1469 26.3038 37.0938 29.0994V21.9688C38.905 23.3862 41.3838 25.3287 45.7113 25.3287C46.8869 25.3287 47.9894 25.1675 49 24.9106V31.3719Z",
  fill: "#9CA3AF"
});

function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.1bf86ebabaa6ca5e052d11cdda26d374.svg";
export { ForwardRef as ReactComponent };